export default {
  props: {
    author: {
      type: Object,
      required: true
    },
    canBeEdited: {
      type: Boolean,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    edited: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    isDeleted: {
      type: Boolean,
      required: true
    },
    isFlaggedByUser: {
      type: Boolean,
      required: true
    },
    flagsCount: {
      type: Number,
      required: false
    },
    pendingModeration: {
      type: Boolean,
      required: true
    },
    sentAt: {
      type: String, // TODO make Date
      required: true
    },
    threadId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      editing: false,
      updateInProgress: false
    }
  },

  methods: {
    cancelEdit() {
      this.editing = false
    },
    editMessage() {
      this.editing = true
    }
  }
}
